export default "__VITE_ASSET__Dbqq21h8__"